export const TIKTOK_PIXEL_ID = process.env.NEXT_PUBLIC_TIKTOK_PIXEL_ID;

export const track = (action, parameter) => {

	window.ttq?.track(action, parameter);

};
